




























import {Component, Prop, Mixins} from 'vue-property-decorator';
import PersonData from '@/ts/PersonData';
import DateMethods from '@/mixins/DateMethods.vue';
import Avatar from '@/components/Media/Avatar.vue';
import ProfileImage from '@/components/Media/ProfileImage.vue';

@Component({
    name: 'EventCardHeader',
    components: {
        Avatar,
        ProfileImage,
    },
})
export default class EventCardHeader extends Mixins(DateMethods) {
    @Prop({ required: true }) public author: PersonData;
    @Prop({ default: false }) public withMedia: boolean;
    @Prop({ default: false }) public isEvent: boolean;
    @Prop() public startTime: string;

    constructor() {
        super();
    }
}
